import { Component, HostBinding, Input } from '@angular/core';

/**
 * Simple modal-wrapping component for modal windows. Controlled by outside. For opening popup set "isShowModal" Input param to true
 * [isShowModal] - boolean, hides or shows the popup
 * [isHiddenMode] - you wan use ngIf or hidden for this modal, by default false
 * See an example of using
 */

// Example of usage
/*
<sn-modal-popup [isShowModal]=" boolean ">
  <ng-container class="sn-modal-header">
    // Header content
  </ng-container>
  <ng-container class="sn-modal-content">
    // Some Content you want place to modal body
  </ng-container>
  <ng-container class="sn-modal-footer">
     // Place for buttons etc.
  </ng-container>
</sn-modal-popup>
*/

// - what can be done more
// separate service for controlling all modals. In this case in this component should be methods for opening and closing
// rewrite salesforce classes and styles
// basic button for closing modal if no any button for footer was added

@Component({
  selector: 'sn-modal-popup',
  templateUrl: './modal-popup.component.html',
  styleUrls: ['./modal-popup.component.sass']
})
export class ModalPopupComponent {
  @HostBinding('class') classes = 'sn-modal';
  @Input() isShowModal: boolean = false;
  @Input() isHiddenMode: boolean = false;
  // private element: any;

  constructor(/*private el: ElementRef*/) {
    // this.element = el.nativeElement;
  }
}
